import { FooterSection } from "../types";

export const footerLinks: FooterSection[] = [
  {
    title: "Information",
    links: [
      { text: "Changelogs", url: "/changelogs" },
      { text: "Rules", url: "/rules" },
      { text: "Blogs", url: "/blog" },
      { text: "Status", url: "/status" },
      { text: "FAQ", url: "/faq" },
      { text: "Team", url: "/teams" },
      { text: "Roadmap", url: "/roadmap" },
      { text: "Contact Us", url: "/contact" },
      { text: "Request My Data", url: "/data-request" },
      // { text: "AI Chat Bot", url: "/aichatbot" },
    ],
  },
  {
    title: "Tools",
    links: [
      { text: "Timezone Checker", url: "/timezone" },
      {
        text: "Vote",
        url: "https://top.gg/bot/1137052528790491228/vote",
        external: true,
      },
    ],
  },
  {
    title: "Support",
    links: [
      {
        text: "Report",
        url: "https://thrivebot.in/support",
        external: true,
      },
      {
        text: "Bug Report",
        url: "https://thrivebot.in/support",
        external: true,
      },
    ],
  },
  {
    title: "Legal",
    links: [
      { text: "Cookie Policy", url: "/cookie-policy" },
      { text: "Privacy Policy", url: "/privacy" },
      { text: "Terms of Service", url: "/tos" },
      { text: "DMCA Policy", url: "/dmca" },
      { text: "GDPR Policy", url: "/gdpr" },
      { text: "CCPA Policy", url: "/ccpa" },
      { text: "Acceptable Use Policy", url: "/aup" },
    ],
  },
  {
    title: "Store",
    links: [
      { text: "Premium", url: "/premium" },
      { text: "Manage Subscriptions", url: "https://thrivebotdiscord.lemonsqueezy.com/billing" },
      { text: "Refund & Cancellation Policy", url: "/refund" },
    ]
    }
];